// import React,{useMemo,useState} from 'react';
import React, { useState, useEffect, useMemo } from "react";
import {useDeleteCategory, useGetAllCategoriesTenantId,useGetBank} from '../../Hooks/Index'
import DyDataGridCustom from '../../../../components/GlobalComponents/DYCustom/DYCustom';
import {Grid, Box,Typography} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import { useSelector } from "react-redux";
// import Button from '@mui/material/Button';
import ModalLyt from "../../../../components/Layouts/ModalLyt/ModalLyt";
// import AddIndex from '../LComponents/AddIndex/AddIndex';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import AddCategory from "../../../Settings/LComponents/AddCategory/AddCategory";
import EditCategory from "../EditCategory/EditCategory";
// import AddLicense from './AddLicense';
const Category = () => {
  // if (loading) {
  //   return <Box columnGap={4} sx={{ width:'100%',display:'flex',justifyContent:'start',flexWrap:'wrap' }}>
  //     {
  //       scletList.map(()=>{
  //         return <Skeleton sx={{my:2}} variant="rounded" width={200} height={180} />
  //       })
  //     }
  //    </Box>
  // }
  const tenantId: string = useSelector(
    (state: any) => state.meetings.profileTenantId
  );
   const {data:dataIndex,isLoading:dataLoading,isError:dataError,refetch:getAgain}=useGetAllCategoriesTenantId(tenantId);
   const{mutate:deleteTeam,isError,isSuccess,data:deleteData}=useDeleteCategory();
//    const {data:databank,isLoading:dataLoadingbank,isError:dataErrorbank}=useGetBank(tenantId);
  const{data,metaData} : any = dataIndex  || {};
  const{appStatusCode}=metaData  || {};
  const [addEvalAsyncData, setAddEvalAsyncData] = useState<any>(null);
  const [SuccessState, setSuccessState] = useState<boolean>(true);
  const [indexSelectionModel, setIndexSelectionModel] = useState<string | any>(
    localStorage.getItem("indexSelectionModel")
  );

  useEffect(() => {
    if (addEvalAsyncData) {
      //callAgain();
      setSuccessState(true);
    }
  }, [addEvalAsyncData]);

  useEffect(() => {
    const indexSelectionModel = localStorage.getItem("indexSelectionModel");
    // console.log(krSelectionModel)
    if (indexSelectionModel) {
      setIndexSelectionModel(indexSelectionModel);
    }
  }, [addEvalAsyncData]);
  // console.log(tenantData)
  const tenantsColumns: any = useMemo(()=>[
    {
      field: "rowid",
      headerName: "ردیف",
      width: 60,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    },
    { field: 'name',
      align:'left',
      headerName: 'شرح',
      headerAlign:'center',
      sortable:false,
      wrap:'wrap',
      width: 170,
      flex:1
    },
  ],[]);
  const [showAddLicense, setShowAddLicense] = useState<boolean>(false);
  const [showToastMessage, setShowToastMessage] = useState<boolean>(false);
  const [showToastMessage2, setShowToastMessage2] = useState<boolean>(false);
  const [historyModal, setHistoryModal] = useState(false);
  const [iuccess, SetIsSuccess] = useState(false);
  const [tMessage, SetTMessage] = useState(false);
  const [krRowData, setKrRowData] = useState(null);
  const [krId, setKrId] = useState(null);
    const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const initialDelete=()=>{
    let deleteBody={
    id:krId
    }
    deleteTeam(deleteBody)
  }

useEffect(() => {
  if (deleteData) {
    if (deleteData?.data.isSuccess) {
      setShowToastMessage2(true);
      SetIsSuccess(true);
      SetTMessage(deleteData?.data.metaData.message);
    } else {
      setShowToastMessage2(true);
      SetIsSuccess(false);
      SetTMessage(deleteData?.data.metaData.message);
    }
  }
}, [deleteData]);


  const renderContent=()=>{
    if (dataLoading) {
      return (<Box  width={'100%'} py={16}   >
        <CircularProgress   />
      </Box>)
    }
    else if(appStatusCode === 7){
      return (<Box  width={'100%'} py={16}   >
         <Typography variant='body1' textAlign={'center'} fontSize={'20px'} fontWeight={700}>
         شما دسترسی به این قسمت را ندارید و باید لایسنس خود را ارتقا دهید
    </Typography>
      </Box>)
    }
    else {
      return <>
       <DyDataGridCustom
     rowHeight={10}
     data={dataError || dataLoading ? []:data }
     columns={tenantsColumns || []}
     hideFooter={false}
    //  selectionModel={[]}
    //  initialOnRowClick={()=>{}}
     additionalToolbar={true}
     setSelectionModel={setIndexSelectionModel}
     setShowHistory={setHistoryModal}
     setSpecialId={setKrId}
     initialOnRowClick={setKrRowData}
     initialDelete={initialDelete}
     /////////////////////selectionModel={indexSelectionModel}
    //  pageSize={5}
    //  filterMode="server"
    //  rowSelection = 'multiple'
    //  rowMultiSelectWithClick ={true}
     /></>
    }
  }
//   const style = {
//     position: 'absolute' as 'absolute',
//     top: '50%',
//     left: '50%',
//     transform: 'translate(-50%, -50%)',
//     width: 400,
//     bgcolor: 'background.paper',
//     border: '2px solid #000',
//     boxShadow: 24,
//     p: 4,
//   };
  const initialAddLicense = (): void => {
    setShowAddLicense((prev) => !prev);
  };


// data,columns,hideFooter,selectionModel,initialOnRowClick
  return (
    <>
    <Grid  sx={{bgcolor:'#F9F9F9',minHeight:'300vh',width:'100% !important',padding:'0px !important'}}   >
     <Grid item xs={12}   >
     <div>
      <Box py={1} display={'flex'} justifyContent={'end'}>
          <button
            onClick={(e: React.MouseEvent<HTMLElement>) =>
              initialAddLicense()
            }
            className={`btn px-4  text-xs font-thin text-white bg-[#00387c]
               btn-sm rounded-md m-2`}
          >
            افزودن 
          </button>
     </Box>
          <ModalLyt
            showModal={showAddLicense}
            setShowModal={setShowAddLicense}
            width={600}
            height={500}
            title={"ثبت"}
          >
            <AddCategory
              onSuccess={setShowAddLicense}
              setShowToastMessage={setShowToastMessage}
              onClose={setShowAddLicense}
            />
          </ModalLyt>
     </div>
     </Grid>
     <Grid item xs={12}   >
     <Box textAlign={'center'}  mx={1} borderRadius={2} boxShadow={2} bgcolor={'white'} my={1} py={dataLoading?8:3}   >
    {
      renderContent()
    }
     </Box>
     {historyModal && (
          <ModalLyt
            title={"ویرایش"}
            showModal={Boolean(historyModal)}
            setShowModal={setHistoryModal}
          >
            <EditCategory
              krDetail={krRowData}
              setShowToastMessage = {setShowToastMessage}
              onClose={setHistoryModal}
            />
          </ModalLyt>
      )}
     </Grid>
     {showToastMessage && (
          <DYToastMessage
            isSuccess={true}
            message={'عملیات با موفقیت انجام شد'}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
        {showToastMessage2 && (
          <DYToastMessage
            isSuccess={iuccess}
            message={tMessage}
            setShow={setShowToastMessage2}
            show={showToastMessage2}
          />
        )}
    </Grid>
    </>
  )
}

export default Category
// import React, { useCallback, useState } from 'react';
// import DataGrid, {
//   Column,
//   Selection,
//   FilterRow,
//   Paging,
//   DataGridTypes,
// } from 'devextreme-react/data-grid';
// import { SelectBox } from 'devextreme-react/select-box';
// import themes from 'devextreme/ui/themes';
// // import { sales } from './data.ts';

// const selectAllFieldLabel = { 'aria-label': 'Select All Mode' };
// const showCheckboxesFieldLabel = { 'aria-label': 'Show Checkboxes Mode' };

// const showCheckBoxesModes = ['none', 'onClick', 'onLongTap', 'always'];
// const selectAllModes = ['allPages', 'page'];

// const Index = () => {
//   const [allMode, setAllMode] = useState<DataGridTypes.SelectAllMode>('allPages');
//   const [checkBoxesMode, setCheckBoxesMode] = useState<DataGridTypes.SelectionColumnDisplayMode>(
//     themes.current().startsWith('material') ? 'always' : 'onClick',
//   );

//   const onCheckBoxesModeChanged = useCallback(({ value }) => {
//     setCheckBoxesMode(value);
//   }, []);

//   const onAllModeChanged = useCallback(({ value }) => {
//     setAllMode(value);
//   }, []);

//   return (
//     <div>
//       <DataGrid dataSource={sales} showBorders={true} keyExpr="orderId">
//         <Selection
//           mode="multiple"
//           selectAllMode={allMode}
//           showCheckBoxesMode={checkBoxesMode}
//         />
//         <FilterRow visible={true} />
//         <Paging defaultPageSize={10} />

//         <Column dataField="orderId" caption="Order ID" width={90} />
//         <Column dataField="city" />
//         <Column dataField="country" width={180} />
//         <Column dataField="region" />
//         <Column dataField="date" dataType="date" />
//         <Column dataField="amount" format="currency" width={90} />
//       </DataGrid>

//       <div className="options">
//         <div className="caption">Options</div>
//         <div className="option">
//           <span>Select All Mode </span>
//           <SelectBox
//             id="select-all-mode"
//             inputAttr={selectAllFieldLabel}
//             dataSource={selectAllModes}
//             value={allMode}
//             disabled={checkBoxesMode === 'none'}
//             onValueChanged={onAllModeChanged}
//           />
//         </div>
//         <div className="option checkboxes-mode">
//           <span>Show Checkboxes Mode </span>
//           <SelectBox
//             id="show-checkboxes-mode"
//             inputAttr={showCheckboxesFieldLabel}
//             dataSource={showCheckBoxesModes}
//             value={checkBoxesMode}
//             onValueChanged={onCheckBoxesModeChanged}
//           />
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Index;